// Reports hooks — per-client progress + trainer business report.
import { useQuery } from "@tanstack/react-query";
import { qk, reportsApi } from "../api";

export function useClientReport(
  clientId: number | undefined,
  period = "all",
) {
  return useQuery({
    queryKey: qk.reports.client(clientId ?? -1, period),
    queryFn: ({ signal }) =>
      reportsApi.client(clientId as number, period, signal),
    enabled: clientId !== undefined && clientId >= 0,
  });
}

export function useBusinessReport(period = "all") {
  return useQuery({
    queryKey: qk.reports.business(period),
    queryFn: ({ signal }) => reportsApi.business(period, signal),
  });
}
